export default interface IConcessionCard {
	cardNumber: string;
	letter: string;
	expireAt: string;
}

export const InitialConcessionCardState: IConcessionCard = {
	cardNumber: "",
	letter: "",
	expireAt: "",
};
